import { ArchiveConfirmDialog } from '~/components/list/archive-confirm-dialog';

/** Confirms archiving one template, from the list's row menu or the editor. */
export const EmailTemplateArchiveDialog = ({
  templateName,
  open,
  failure,
  isArchiving,
  onCancel,
  onConfirm
}: {
  /** Absent while the dialog closes, so its title falls back to "template". */
  templateName: string | undefined;
  open: boolean;
  failure: string | null;
  isArchiving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) => (
  <ArchiveConfirmDialog
    open={open}
    count={1}
    itemNoun="template"
    title={`Archive ${templateName ?? 'template'}?`}
    description="It won't show up for new emails. Drafts and sent emails keep their text."
    error={failure}
    loading={isArchiving}
    onCancel={onCancel}
    onConfirm={onConfirm}
  />
);
